<template>
  <b-navbar toggleable="lg" class="container">
    <b-navbar-brand :to="{ name: 'home' }"
      ><b-img src="@/assets/images/logo.png" fluid class="logo"></b-img
    ></b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item
          v-for="(nav, i) in navList"
          v-if="!nav.child"
          :key="i"
          :to="nav.to"
          class="mx-2"
          >{{ nav.name }}</b-nav-item
        >
        <b-nav-item-dropdown
          v-else
          id="my-nav-dropdown"
          :text="nav.name"
          toggle-class="nav-link-custom"
          no-caret
          class="mx-2"
        >
          <b-dropdown-item
            v-for="(navChild, i) in nav.child"
            :key="i"
            :to="navChild.to"
            >{{ navChild.name }}</b-dropdown-item
          >
        </b-nav-item-dropdown>
        <b-nav-item
          to="/files/ScanTop_Catalogue_2026.pdf"
          downland
          target="_blank"
          >Catalogue</b-nav-item
        >
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item :to="{ name: 'contact' }" class="contact">
          <div class="icon mr-2">
            <font-awesome-icon icon="envelope" />
          </div>
          Contact Us
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        { name: "About", to: { name: "about" } },
        { name: "Products", to: { name: "products" } },
        {
          name: "Production",
          child: [
            { name: "Production Steps", to: { name: "production" } },
            {
              name: "Automatic System",
              to: { name: "production", hash: "#auto" },
            },
            { name: "QAD", to: { name: "production", hash: "#qad" } },
          ],
        },
        {
          name: "Technology",
          child: [
            { name: "Patent", to: { name: "patent" } },
            {
              name: "Installation Videos",
              to: { name: "patent", hash: "#videos" },
            },
            { name: "Laboratory", to: { name: "laboratory" } },
            {
              name: "Certification",
              to: { name: "laboratory", hash: "#certification" },
            },
          ],
        },
        {
          name: "Trade Shows",
          to: { name: "trade-shows" },
        },
        { name: "Search", to: { name: "search" } },
      ],
    };
  },
};
</script>

<style lang="scss">
.navbar {
  height: auto;
  z-index: 12;
  background-color: #fff;

  .navbar-nav {
    .nav-item a {
      font-family: Roboto;
      letter-spacing: 2px;
      color: rgba(91, 90, 90, 1);
      font-size: 0.85rem;
    }
  }
}
#nav-collapse {
  z-index: 12;
  background-color: #fff;
}
.logo {
  max-height: 30px;
}
.contact {
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-main !important;

    .icon {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      width: 30px;
      height: 30px;
      background: $color-main;
      border-radius: 150px;
      color: #fff;
    }
  }
}
@media (min-width: 992px) {
  .navbar {
    height: 85px;
  }
  .logo {
    max-height: 45px;
  }

  nav.navbar-light .navbar-nav:first-child .nav-link {
    position: relative;
    transition: all 0.3s;
    overflow: hidden;
    transition: all 0.3s;

    &:hover {
      color: $color-main;
    }

    &::after {
      content: "";
      display: block;
      position: absolute;
      left: 8px;
      right: 100%;
      margin-top: 3px;
      height: 2px;
      background-color: $color-main;
    }

    &.router-link-exact-active {
      &::after {
        right: 8px;
      }
    }
  }
}
</style>